<template>
  <div v-if="multiple" class="multiple-dragdrop">
    <div class="dragdrop">
      <em class="icon-cloud-outline nm mrs"></em>
      <p class="nm mbt">
        {{
          resolveTxt("skin.upload.link.before", "Drag your file(s) in here, or")
        }}
        <a class="clicktoselect">{{
          resolveTxt("skin.upload.link", "browse")
        }}</a>
        {{
          resolveTxt(
            "skin.upload.link.after",
            "to upload shareholders in bulk."
          )
        }}
        <span class="nowrap"
          >{{ resolveTxt("skin.upload.allowed.formats", "Allowed formats") }}
          <strong class="all-black">{{
            resolveTxt("skin.upload.allowed.formats.types", "CSV, XLS, DOCX")
          }}</strong></span
        >
      </p>
    </div>
    <div class="button-set">
      <input
        type="submit"
        class="button secondary"
        :value="resolveTxt('skin.upload.button.name', 'Upload Shareholders')"
      />
      <slot name="buttons"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);

    return {
      resolveTxt
    };
  },

  name: "CatUpload",
  data: function () {
    return {
      multiple: true
    };
  }
});
</script>
